import { useEventFollow } from "@/hooks/use-event-follow";
import { formatMonetaryValue } from "@/utils/utils";
import { ArrowLeft } from "lucide-react";
import { Love } from "../ui/love";

interface EventDetailHeaderProps {
    isSingleGuessDetailPage: boolean;
    tradeAmount: number;
    onBack: () => void;
    eventData: { eventNo: string; followed: boolean };
}

/**
 * 事件详情页头部
 * - 单独页面模式：显示返回按钮 + Volume
 * - 普通模式：只显示 Volume
 */
export function EventDetailHeader(
    { isSingleGuessDetailPage, tradeAmount, onBack, eventData }: EventDetailHeaderProps,
) {
    const { followed, handleLoveClick } = useEventFollow( eventData );

    if ( isSingleGuessDetailPage ) {
        return (
            <div className="sticky top-0 left-0 right-0 z-30 -mx-4 flex h-11 w-[calc(100%+32px)] max-w-[500px] items-center justify-between gap-3 bg-surface-base px-4">
                <button onClick={onBack} className="p-1 -ml-1">
                    <ArrowLeft className="size-6 text-t1" />
                </button>
                <div className="flex items-center gap-3">
                    <div className="text-sm font-[400] text-t3">
                        {`${formatMonetaryValue( tradeAmount || 0 )} Vol`}
                        {/*{calc( "tradeAmount | <=2!ub:$", { tradeAmount } )} vol*/}
                    </div>
                    <Love className="size-4" isLove={followed} onClick={handleLoveClick} />
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center w-full">
            <div className="text-sm font-[400] text-t3 pt-4">
                {`${formatMonetaryValue( tradeAmount || 0 )} Vol`}
                {/*{calc( "tradeAmount | <=2!ub:$", { tradeAmount } )} vol*/}
            </div>
            <div className="ml-auto pt-4">
                <Love className="size-4" isLove={followed} onClick={handleLoveClick} />
            </div>
        </div>
    );
}
